import { throttle, put, select, all, call } from 'redux-saga/effects';

import axios from 'axios';

import {
  sendFormDataSuccess,
  sendFormDataFailure,
} from './from-trueblue.actions';

import { selectCurrentUser } from '../user/user.selector';
import { TrueBlueFormTypes } from './from-trueblue.types';

export function* sendFormData(action) {
  try {
    const user = yield select(selectCurrentUser);
    const formData = action.payload;
    const { agentName, customerName, dof, pnr, tbn, comment } = formData;

    const response = yield call(axios, {
      url: process.env.REACT_APP_LOCAL_URL + '/survey/truebluepoints',
      method: 'post',
      data: {
        agentName,
        customerName,
        dof,
        pnr,
        tbn,
        comment,
        userAuth: user,
      },
    });

    if (response.data.status === 'success') {
      yield put(sendFormDataSuccess());
    } else {
      alert('Error saving form data ');
    }
  } catch (error) {
    alert('Error during form data submission');
    yield put(sendFormDataFailure(error));
  }
}

export function* onsendFormData() {
  yield throttle(10000, TrueBlueFormTypes.SEND_FORM_DATA_START, sendFormData);
}

export function* trueblueFormSagas() {
  yield all([call(onsendFormData)]);
}
